<!-- Right hand side panel for creating/editing resources -->

<template>
  <div id="side-panel" :style="{ width: computedWidth }">
    <div id="header">
      <slot name="title"></slot>
      <v-icon id="close" @click="close">mdi-close</v-icon>
    </div>
    <slot name="content"></slot>
  </div>
</template>

<script>
export default {
  name: 'SidePanel',
  props: {
    width: {
      type: String,
      default: '50%',
    },
  },
  computed: {
    computedWidth() {
      if (this.$vuetify.display.smAndDown) {
        return '100%';
      }

      return this.width;
    },
  },
  methods: {
    close() {
      this.$emit('close', true);
    },
  },
};
</script>

<style>
  #side-panel {
    height: calc(100vh);
    width: 500px;
    background: white;
    box-shadow: -5px 0 5px rgba(0,0,0,0.125);
    position: fixed;
    top: 0;
    right: 0;
    padding: 30px;
    overflow-y: auto;
    z-index: 1007;
  }
  #header {
    margin-bottom: 30px;
  }
  #close {
    position: absolute;
    right: 30px;
    top: 30px;
  }
  #side-panel + .container {
    /*
      Kind of a hacky way to ensure content does not flow under the panel.
      The layout should be
      <side-panel>...</side-panel>
      <v-container>...</v-container>
    */
    padding-right: 400px !important;
  }
</style>
